import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { Setting } from '@app-state';
import { RoleOrigin, RolesAssignment, UserType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { AssignUserModalComponent } from '@pages/folders/modals';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { FoldersService, MapperService, } from '@services';
import { addToObjectIf } from '@utils/object.utils';
import { BehaviorSubject, } from 'rxjs';
import { map, switchMap, takeUntil, } from 'rxjs/operators';
var FolderUsersSource = /** @class */ (function () {
    function FolderUsersSource(_foldersService) {
        this._foldersService = _foldersService;
        this.includeInheritedUsers = false;
    }
    Object.defineProperty(FolderUsersSource.prototype, "mapper", {
        get: function () {
            return MapperService.folderAssignmentsMap;
        },
        enumerable: true,
        configurable: true
    });
    FolderUsersSource.prototype.get = function (queryOptions) {
        return this._foldersService.getAssignedUsers(this.folderId, this.includeInheritedUsers, queryOptions);
    };
    return FolderUsersSource;
}());
export { FolderUsersSource };
var FolderUsersGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FolderUsersGridComponent, _super);
    function FolderUsersGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.RolesAssignment = RolesAssignment;
        _this.UserType = UserType;
        _this.isWindowsAuthenticationEnabled = _this._appState.settings.get(Setting.isWindowsAuthEnabled);
        _this._folder$ = new BehaviorSubject(null);
        _this._includeInheritedUsers = false;
        _this._foldersService = _this._injector.get(FoldersService);
        _this._translateService = _this._injector.get(TranslateService);
        return _this;
    }
    Object.defineProperty(FolderUsersGridComponent.prototype, "folder", {
        get: function () {
            return this._folder$.value;
        },
        set: function (folder) {
            var svc = this._service;
            svc.folderId = folder.id;
            this._folder$.next(folder);
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FolderUsersGridComponent.prototype, "includeInheritedUsers", {
        get: function () {
            return this._includeInheritedUsers;
        },
        set: function (value) {
            var svc = this._service;
            this._includeInheritedUsers = svc.includeInheritedUsers = value;
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    FolderUsersGridComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.processedData$ = this.data$
            .pipe(map(function (data) {
            return data.map(function (entry) {
                entry.rolesInheritance = _this._getRolesDetails(entry.user, entry.roles);
                return entry;
            });
        }), takeUntil(this._destroyed$));
        this._appState.language.change$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function () { return _this._refresh$.next(); });
        this.hasPermissionsToOpenMenu$ = this._folder$.pipe(switchMap(function (folder) { return _this._appState.user.folderPermissions
            .isGranted(folder.id, 'Units.Edit | SubFolders.Edit'); }));
    };
    FolderUsersGridComponent.prototype.openAssignUserModal = function (entry, isLocalUser) {
        var _this = this;
        if (isLocalUser === void 0) { isLocalUser = true; }
        this._modal
            .openModal(AssignUserModalComponent, tslib_1.__assign({ folder: this.folder }, addToObjectIf(!!entry, { assignment: entry })), { data: { isLocalUser: isLocalUser } })
            .afterClosedResult()
            .subscribe(function (result) { return result && _this._refresh$.next(); });
    };
    FolderUsersGridComponent.prototype.unassignUser = function (entry) {
        var _this = this;
        this._modal.onConfirm(null, function () {
            _this._foldersService
                .removeUserFromFolder(_this._folder$.value.id, entry.user.id)
                .subscribe(function () { return _this._refresh$.next(); });
        }, function () { }, this._translateService.instant('folder_users_grid_are_you_sure_unassign'));
    };
    FolderUsersGridComponent.prototype._getRoleOrigin = function (user, role) {
        return role.origin === RoleOrigin.Assigned
            ? user.isInherited
                ? " (" + this._translateService.instant('folder_users_grid_inherited_from_tenant') + ")"
                : ''
            : " (" + this._translateService.instant('folder_users_grid_inherited_from', { folder: role.inheritedFromFolder.displayName }) + ")";
    };
    FolderUsersGridComponent.prototype._getRolesDetails = function (user, roles) {
        var _this = this;
        return roles
            .map(function (role) { return "" + role.name + _this._getRoleOrigin(user, role); })
            .join(', ');
    };
    return FolderUsersGridComponent;
}(ODataGridComponent));
export { FolderUsersGridComponent };
